import Header from '../common/Header/Header';
import { useTranslation } from 'react-i18next';
import RuleForm from './components/RuleForm';
import './enrollmentRules.scss';

const CreateNewRule = () => {
  const { t } = useTranslation();
  return (
    <div className="create-new-rule container-fluid">
      <Header
        linkTo={'/admin/enrollment-rules'}
        header={t('admin.pages.enrollment_rules.create_rules.title')}
      />
      <RuleForm />
    </div>
  );
};

export default CreateNewRule;
